import React from 'react';
import { useSelector } from 'react-redux';
import Button, {
  ButtonType,
} from '../../../../../../../components/common/button';
import { Visibility } from '../../../../../../../types/common-types';
import { ApplicationState } from '../../../../../../../store';

interface ButtonProps {
  id: string;
  type: ButtonType;
  error?: boolean;
  title: string;
  style?: object;
  extra?: object;
  visibility: Visibility;
  onSubmit: (id: string, buttonData: Record<string, unknown>) => void;
}

const ButtonBF: React.FC<ButtonProps> = ({
  id,
  title,
  type,
  error,
  visibility,
  onSubmit,
  extra,
  style,
}) => {
  const { submitingButtonId } = useSelector(
    (state: ApplicationState) => state.page
  );
  return (
    <Button
      id={id}
      type={type}
      style={style}
      extra={extra}
      error={error}
      visibility={visibility}
      label={title}
      submiting={type === ButtonType.Submit && submitingButtonId === id}
      className="button"
      onClick={() => onSubmit(id, { isButton: true })}
    />
  );
};
export default ButtonBF;
